<template>
  <div>
    <ForeignOrganization :v="v" />

    <OrganizationTrustee
      :v="v.trustee"
      label="Сведения о представителе иностранного юридического лица"
    />
  </div>
</template>

<script>
import { getValidationErrorText } from '@/utils/validate';
import { FieldName } from '@/constants';
import ForeignOrganization, {
  foreignOrganizationModel,
  foreignOrganizationValidation,
  prefillEsiaForeignOrg,
} from '@/components/services/EgrnConfirm/Applicant/components/ForeignOrganization';
import OrganizationTrustee, {
  organizationTrusteeModel,
  getOrganizationTrusteeValidation,
  prefillEsiaOrgTrustee,
} from '@/components/services/EgrnConfirm/Applicant/components/OrganizationTrustee';
import deepmerge from 'deepmerge';
import cloneDeep from 'clone-deep';

export const mrpaEnableTrusteeForeignOrganizationModel = deepmerge(
  foreignOrganizationModel,
  {
    trustee: organizationTrusteeModel,
  }
);

export const getMrpaEnableTrusteeForeignOrganizationValidation = (
  foreignOrganization
) => ({
  ...foreignOrganizationValidation,
  trustee: getOrganizationTrusteeValidation(foreignOrganization.trustee),
});

export const prefillEsiaMrpaEnableTrusteeForeignOrganization = async () => {
  const esiaOrg = await prefillEsiaForeignOrg();

  return cloneDeep({
    ...mrpaEnableTrusteeForeignOrganizationModel,
    ...esiaOrg,
    trustee: await prefillEsiaOrgTrustee(),
  });
};

export default {
  name: 'MrpaEnableTrusteeForeignOrganization',
  props: {
    v: {
      type: Object,
      required: true,
    },
  },
  components: {
    ForeignOrganization,
    OrganizationTrustee,
  },
  data: () => ({
    getValidationErrorText,
    FieldName,
  }),
};
</script>
